import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { BE_API_AUTH_URL } from '../constants/app.constants';

@Injectable({
  providedIn: 'root',
})
export class AdminSeatsService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  getPlans(): Observable<any[]> {
    return this.http
      .get<any[]>(`${BE_API_AUTH_URL}/admin/plans`, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  updatePlan(planKey: string, defaultMaxUsers: number): Observable<any> {
    return this.http
      .put(`${BE_API_AUTH_URL}/admin/plans/${planKey}`, { defaultMaxUsers }, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  getCompanies(): Observable<any[]> {
    return this.http
      .get<any[]>(`${BE_API_AUTH_URL}/admin/companies`, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  updateCompanySeats(companyId: string, payload: { seatLimit: number | null; seatEnforcementEnabled: boolean }): Observable<any> {
    return this.http
      .put(`${BE_API_AUTH_URL}/admin/companies/${companyId}/seats`, payload, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  updateCompanySso(companyId: string, payload: {
    ssoAutoJoinEnabled: boolean;
    allowedDomains: string[];
    allowedTenantIds: string[];
  }): Observable<any> {
    return this.http
      .put(`${BE_API_AUTH_URL}/admin/companies/${companyId}/sso`, payload, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  updateCompanyIntegrations(companyId: string, payload: { integrationLimit: number }): Observable<any> {
    return this.http
      .put(`${BE_API_AUTH_URL}/admin/companies/${companyId}/integrations`, payload, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  getSftpEndpoint(): Observable<any> {
    return this.http.get(`${BE_API_AUTH_URL}/admin/integrations/sftp/endpoint`, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  updateSftpEndpoint(payload: any): Observable<any> {
    return this.http.put(`${BE_API_AUTH_URL}/admin/integrations/sftp/endpoint`, payload, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  getSftpRequests(): Observable<any> {
    return this.http.get(`${BE_API_AUTH_URL}/admin/integrations/sftp/requests`, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  getSftpRequest(connectionId: string): Observable<any> {
    return this.http.get(`${BE_API_AUTH_URL}/admin/integrations/sftp/${connectionId}`, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  markSftpReady(connectionId: string, payload: any): Observable<any> {
    return this.http.put(`${BE_API_AUTH_URL}/admin/integrations/sftp/${connectionId}/ready`, payload, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  changeSftpState(connectionId: string, action: 'pause' | 'resume' | 'disconnect' | 'error'): Observable<any> {
    return this.http.post(`${BE_API_AUTH_URL}/admin/integrations/sftp/${connectionId}/${action}`, {}, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }
}
